import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import * as sha512 from 'js-sha512';
import { ApiService } from '../api.service';
import { Platform } from '@ionic/angular';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { PushMsgService } from '../push.service';


@Component({
  selector: 'app-account-validate',
  templateUrl: './account-validate.component.html',
  styleUrls: ['./account-validate.component.scss'],
})
export class AccountValidateComponent {
  @ViewChild('ngOtpInput', { static: false}) ngOtpInput: any;
  @ViewChild('ngOtpInput') ngOtpInputRef:any;
  counter;
  value;
  interval;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      'width': '30px',
      'height': '30px'
    }
  };
  intervalId = 0;
message = '';
seconds = 21;
  phone; check: boolean = false;loader:boolean = false;
  otp; mobileVerify: any = {};verify;url;id;
  itemTypeId;
  smsTextmessage;
  otpValue;
  trigger:boolean = true;
  reSend:boolean = false;
  popup:boolean = false;
  place;
  locationTrue;
  locat;
  locAd=[]
  public appHashString: string = '';


  constructor(private auth: AuthService,
    public handler: HandlerService,
    public router: Router,
    public service:ApiService,
    public platform: Platform,
    private push: PushMsgService,
    public smsRetriever: SmsRetriever) { }

    ionViewWillEnter() {
      this.popup=false;
      this.counter = 21;
      this.interval = 1000;
      setTimeout(() => {
        this.reSend = true;
      }, 20000);
      if(this.platform.is('android')){
        this.getSMS();
      }
      this.phone = sessionStorage.getItem('contactNbrMob') ;
        this.id=sessionStorage.getItem('id')  
        this.itemTypeId=sessionStorage.getItem('itemTypeId')
        this.backUpLocation()
    }

    getSMS() {
      this.smsRetriever.startWatching()
      .then((res: any) => {
        this.smsTextmessage = res.Message;
        var y = this.smsTextmessage.split(':');
        this.otpValue = y[1].slice(1,7);
        this.ngOtpInputRef.setValue(this.otpValue);
        // this.autoValidMobileOtp(this.otpValue);
      })
      .catch((error: any) => console.error(error));
      
    }
    getHashCode() {
      // this.otpClicked = false;
      if(this.platform.is('android')){
        this.smsRetriever.getAppHash()
        .then((res: any) => {
          this.appHashString = res;
          this.sendOtp();
        })
        .catch((error: any) => {
          this.sendOtp();
        });
      }else{
        this.sendOtp();
      }
    }
  
    sendOtp() {
      this.reSend = false;
      this.loader = true;
      var post={
        "contactNbrMob":'+91'+ this.phone
      }
      if(this.platform.is('android')){
        Object.assign(post,{ "hashSms" : this.appHashString})
      }
      this.service.customerLogin(post).subscribe(res => {    
        if(this.platform.is('android')){
          Object.assign(res,{ "hashSms" : this.appHashString})
        }  
        this.loader = false;
        setTimeout(() => {
          this.reSend = true;
        }, 30000);
        this.handler.res('OTP Sent Successfully');

      },err=>{
        this.handler.err(err);      
        this.loader = false;
      })
   
    }



    
    onOtpChange(otp) {
      setTimeout(() => {
        this.otp = otp;
        this.validMobileOtp();
      }, 500);
    }
 
    validateNumber(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 13);
      this.phone = event.target.value
    }
  
    validate(event) {
      console.log(event)
      event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 6);
      this.otp = event.target.value;
      this.validMobileOtp()
    }

    onpaste1(event){
      console.log(event)
    }
  
    onpaste(event) {
      let clipboardData = event.clipboardData;
      let pastedText = clipboardData.getData('text');
      event.target.value = pastedText.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 6);
      this.otp = event.target.value;
      this.validMobileOtp()
    }

    validMobileOtp() {
      if (this.otp.length == 6) {
        if (this.otp != undefined || null) {
          var m = sha512.sha512(this.otp.toString());
        }
        this.mobileVerify = { contactNbrMob:'+91'+this.phone, mobileOTP: m }
        this.loader = true;
        this.service.validateOtpForYb(this.mobileVerify).subscribe((res:any) => {
          window['mock'] = res;
          this.handler.validateRes(res);  
          this.handler.loginRes(res); 
          sessionStorage.setItem('newId',res.userId)   
          this.handler.res('Validated Successfully !!')
          this.auth.getUser();
          this.getCapability(res.userId); 
          this.auth.getConfig();
          if(this.platform.is('android') || this.platform.is('ios')){
            this.push.getToken();
          }
   
        },
          err => {
            this.handler.err(err);
            this.loader = false;
          })
      }
    }

    autoValidMobileOtp(data) { 
        if (data != undefined || null) {
          var m = sha512.sha512(data.toString());
        }
        this.mobileVerify = { contactNbrMob:'+91'+this.phone, mobileOTP: m }
        this.loader = true;
        this.service.validateOtpForYb(this.mobileVerify).subscribe((res:any) => {
          window['mock'] = res;
          this.handler.validateRes(res);  
          this.handler.loginRes(res);  
          sessionStorage.setItem('newId',res.userId)  
          this.handler.res('Validated Successfully !!')
          this.auth.getUser();
          this.getCapability(res.userId); 
          this.auth.getConfig();
   
        },
          err => {
            this.handler.err(err);
            this.loader = false;
          })
        }
    
  
    goToPage() {
      this.loader = false;
      let url=window.location.href
       if(url.includes('validateForOrder')){
        sessionStorage.setItem('itemTypeId',this.itemTypeId)
        sessionStorage.setItem('dummyValue','true')
        sessionStorage.setItem('login','true')
        this.router.navigate(['/subservice1']);    
      }else if(url.includes('validateForSubs')){
        this.router.navigate(['/subs-booking'])
      }else if(url.includes('validateForPurc')){
        this.router.navigate(['purchase-items1/', this.id]);  
      }else if(url.includes('validateProfile')){
        this.router.navigate(['/bookservice1']);  
      }else if(url.includes('employeeCheck')){
        if(this.auth.checkCapability('SC')){
        sessionStorage.setItem('vendorApp','true')
          this.router.navigate(['/requests']); 
        }else if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')&&!this.auth.checkCapability('SC')){
          sessionStorage.setItem('vendorApp','true')
          this.router.navigate(['/vendor-request']);
        }else if((this.auth.checkCapability('FSA')||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))&&!this.auth.checkCapability('SC')){
          console.log('only fsa')
          sessionStorage.setItem('vendorApp','true')
          this.router.navigate(['/vendor-manage-order']);
        }else if((!this.auth.checkCapability('SC') && !this.auth.checkCapability('FSA') && !this.auth.checkCapability('SP'))){
          // this.router.navigate(['/bookservice']);
          this.popup = true;
        }else{
          sessionStorage.setItem('vendorApp','true')
          this.router.navigate(['/vendor-request']);
        }
      }else if( url.includes('contractorReg')){
        this.router.navigate(['/vendorCategory'])       
           }else{
        this.router.navigate(['/profile']);
      }

    }

    getCapability(id) {  
      this.service.getCapability(id).subscribe((res: any) => {    
          let capabilities = res.capabilities.map(({ code }) => code);
          localStorage.setItem('capability', JSON.stringify(capabilities));
          localStorage.setItem('capabilityOrg', JSON.stringify(res.orgs)); 
          if(localStorage.getItem('capabilityOrg')) {
             this.loader = false;
             this.goToPage()
            //  this.auth.getOrg();
          }    
          },
        err => {
          this.handler.err(err);
          this.loader = false;
        })
  
  }
  cancel(){
    this.popup=false;
    localStorage.clear();
    sessionStorage.clear();  
    if(this.place){
      localStorage.setItem('place',JSON.stringify(this.place));
      localStorage.setItem('locationTrue',this.locationTrue);
    }
    if(this.locat){
      localStorage.setItem('location',JSON.stringify(this.locat));
      localStorage.setItem('locationTrue',this.locationTrue);
    }
    // if(this.locAd){
    //   localStorage.setItem('ads',JSON.stringify(this.locAd));
    // }   
    this.router.navigate(['/bookservice']); 
    this.loader=false; 
  }
  backUpLocation(){
    if(localStorage.getItem('place')){
      this.place = JSON.parse(localStorage.getItem('place'));
      this.locationTrue = localStorage.getItem('locationTrue');
    }
    if(localStorage.getItem('location')){
      this.locat = JSON.parse(localStorage.getItem('location'));
      this.locationTrue = localStorage.getItem('locationTrue');
    }
    if(localStorage.getItem('ads')){
      this.locAd = JSON.parse(localStorage.getItem('ads'));
    
    }
  }
  ionViewWillLeave(){
    this.popup=false;
  }

}
